import { render, staticRenderFns } from "./ActiveLimit.vue?vue&type=template&id=6a542e4a&scoped=true&"
import script from "./ActiveLimit.vue?vue&type=script&lang=ts&"
export * from "./ActiveLimit.vue?vue&type=script&lang=ts&"
import style0 from "./ActiveLimit.vue?vue&type=style&index=0&id=6a542e4a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a542e4a",
  null
  
)

export default component.exports